import { useTranslation } from 'react-i18next';

export default function EmergencyBar() {
  const { t } = useTranslation('reparation');

  return (
    <a
      href="tel:+14184769950"
      aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
      title="Cliquez pour appeler"
      className="fixed top-0 left-0 right-0 z-[60] bg-urgent text-white text-center py-2.5 px-4 text-sm md:text-base font-semibold flex items-center justify-center gap-2 hover:bg-urgent-dark transition-colors whitespace-nowrap"
    >
      <span className="hidden sm:inline">{t('emergency_bar')}</span>
      <span className="sm:hidden flex items-center gap-2">
        <i className="ri-alarm-warning-line" />
        Urgence : {t('phone_number')}
      </span>
    </a>
  );
}